/*----------------------------------------

Since connect account payments require 
specifying the target account when we first
instantiate a stripe instance we need a 
custom hook to prevent re-instantiating the
stripe object on re-renders. 

----------------------------------------*/

import {loadStripe} from '@stripe/stripe-js';
import {envAwarePost} from '../util/util'

//placed this in global scope so that it gets set
//once and says set
let stripePromise = false
let currentStripeAccount = false

const useStripeAccount = async (stripeAccount)=>{
	//if no stripe promise return a newly created instance
	//else return the existing instance
	if (!stripePromise || currentStripeAccount !== stripeAccount) {
		currentStripeAccount = stripeAccount
		//not alll legacy connect payments are run through the old fitsw connect account
		const pk = (
			window.location.hostname.includes('localhost')
			? 'pk_test_J1rw2W7wNSutjaPXSaiSQlUI'
			: 'pk_live_URta1rVgTlKsYEn61TYBEJtI'
		)

		stripePromise = await loadStripe(
			pk,
			{stripeAccount}
		)
	}
	return stripePromise
}

export default useStripeAccount